import { FormConfig, SelectOption } from '@lbcamden/lib-react';

import { sanitiseNumberString } from '~/client/utils/string';
import { PropertyDetails, PropertyDetailsUpdate } from '~/common/types/buildings';
import { ReferenceListType } from '~/common/types/data';

export const propertyDetailsFormConfig = (
  referenceListSelectOptions: (type: ReferenceListType) => SelectOption[],
) =>
  ({
    fieldSections: [
      {
        title: 'Building information',
        fields: ['floorLevel', 'adaptation', 'heatingType', 'accessibleLift'],
      },
      { title: 'Next of kin', fields: ['nextOfKinName', 'nextOfKinTelephone', 'nextOfKinAddress'] },
    ],
    fieldConfigs: {
      floorLevel: {
        autocomplete: true,
        selectOptions: referenceListSelectOptions('FLOORLEVEL'),
      },
      adaptation: {
        selectOptions: referenceListSelectOptions('ADAPTATION'),
      },
      heatingType: {
        selectOptions: referenceListSelectOptions('HEATTYPE'),
      },
      accessibleLift: {
        selectOptions: referenceListSelectOptions('LIFT'),
      },
      nextOfKinName: { label: 'Name' },
      nextOfKinTelephone: { label: 'Phone number', sanitiseFn: sanitiseNumberString },
      nextOfKinAddress: { label: 'Address' },
    },
  }) satisfies FormConfig<PropertyDetails>;

export const sanitiseUpdate = (propertyDetails: PropertyDetails, update: PropertyDetailsUpdate) => {
  const updateKeys = Object.keys(update).filter(
    (key) => !['propertyId', 'propertyRef', 'tenancyId', 'isPcfra'].includes(key),
  ) as Exclude<
    keyof PropertyDetailsUpdate,
    'propertyId' | 'propertyRef' | 'tenancyId' | 'isPcfra'
  >[];

  updateKeys.forEach((key) => {
    const updateValue = update[key];

    // Discard unchanged fields
    // We're currently unable to pass empty strings so these need to be discarded too
    if ([propertyDetails[key]?.trim(), ''].includes(updateValue as never)) {
      delete update[key];
    }
  });

  return update;
};
